// evaluateKids.js — REFATORADO
// Normalização 0–100 por eixo + gatilhos Regenera, mesma interface do Baby

import { baseResult, norm05to10, normYesNo, safeGetRaw } from "./evalShared";

const TYPE = { SCALE: "escala_0_5", YESNO: "sim_nao", STOOL: "fezes_ABCD" };
const AXIS = { DIGEST: "digest", IMMUNE: "immune", BRAIN: "brain" };

// --- mapeamento (igual ao teu arquivo) ---
const meta = {
  518: { type: TYPE.SCALE, axis: AXIS.DIGEST, invert: false, regenera: null },
  519: { type: TYPE.YESNO, axis: AXIS.DIGEST, invert: true,  regenera: null },
  520: { type: TYPE.SCALE, axis: AXIS.DIGEST, invert: true,  regenera: null },
  521: { type: TYPE.SCALE, axis: AXIS.DIGEST, invert: true,  regenera: null },
  522: { type: TYPE.SCALE, axis: AXIS.DIGEST, invert: true,  regenera: null },
  523: { type: TYPE.SCALE, axis: AXIS.DIGEST, invert: false, regenera: null },
  524: { type: TYPE.SCALE, axis: AXIS.DIGEST, invert: false, regenera: null },
  525: { type: TYPE.SCALE, axis: AXIS.DIGEST, invert: false, regenera: null },
  526: { type: TYPE.SCALE, axis: AXIS.DIGEST, invert: true,  regenera: null },
  527: { type: TYPE.SCALE, axis: AXIS.DIGEST, invert: false, regenera: null },
  528: { type: TYPE.SCALE, axis: AXIS.DIGEST, invert: false, regenera: null },
  529: { type: TYPE.SCALE, axis: AXIS.DIGEST, invert: false, regenera: "G3" },
  530: { type: TYPE.STOOL, axis: AXIS.DIGEST, invert: false, regenera: "G3" },
  531: { type: TYPE.SCALE, axis: AXIS.DIGEST, invert: false, regenera: "G2" },

  532: { type: TYPE.SCALE, axis: AXIS.IMMUNE, invert: false, regenera: null },
  533: { type: TYPE.SCALE, axis: AXIS.IMMUNE, invert: false, regenera: null },
  534: { type: TYPE.SCALE, axis: AXIS.IMMUNE, invert: false, regenera: null },
  535: { type: TYPE.YESNO, axis: AXIS.IMMUNE, invert: false, regenera: null },
  536: { type: TYPE.SCALE, axis: AXIS.IMMUNE, invert: false, regenera: null },
  537: { type: TYPE.SCALE, axis: AXIS.IMMUNE, invert: false, regenera: null },
  538: { type: TYPE.YESNO, axis: AXIS.IMMUNE, invert: false, regenera: null },

  539: { type: TYPE.YESNO, axis: AXIS.IMMUNE, invert: false, regenera: null },
  540: { type: TYPE.SCALE, axis: AXIS.IMMUNE, invert: false, regenera: null },
  541: { type: TYPE.YESNO, axis: AXIS.IMMUNE, invert: false, regenera: "G1" },
  542: { type: TYPE.SCALE, axis: AXIS.IMMUNE, invert: false, regenera: null },
  543: { type: TYPE.SCALE, axis: AXIS.IMMUNE, invert: true,  regenera: null },
  544: { type: TYPE.YESNO, axis: AXIS.IMMUNE, invert: true,  regenera: null },
  545: { type: TYPE.SCALE, axis: AXIS.IMMUNE, invert: false, regenera: null },

  546: { type: TYPE.SCALE, axis: AXIS.BRAIN,  invert: false, regenera: null },
  547: { type: TYPE.SCALE, axis: AXIS.BRAIN,  invert: false, regenera: null },
  548: { type: TYPE.SCALE, axis: AXIS.BRAIN,  invert: true,  regenera: null },
  549: { type: TYPE.SCALE, axis: AXIS.BRAIN,  invert: false, regenera: null },
  550: { type: TYPE.SCALE, axis: AXIS.BRAIN,  invert: true,  regenera: null },
  551: { type: TYPE.SCALE, axis: AXIS.BRAIN,  invert: true,  regenera: null },

  552: { type: TYPE.YESNO, axis: AXIS.IMMUNE, invert: false, regenera: null },
  553: { type: TYPE.SCALE, axis: AXIS.IMMUNE, invert: false, regenera: null },
  554: { type: TYPE.YESNO, axis: AXIS.IMMUNE, invert: false, regenera: null },
  555: { type: TYPE.SCALE, axis: AXIS.IMMUNE, invert: true,  regenera: null },
  556: { type: TYPE.SCALE, axis: AXIS.IMMUNE, invert: false, regenera: null },
  557: { type: TYPE.YESNO, axis: AXIS.DIGEST, invert: false, regenera: null },
  558: { type: TYPE.YESNO, axis: AXIS.DIGEST, invert: false, regenera: "G4" },
  559: { type: TYPE.YESNO, axis: AXIS.BRAIN,  invert: false, regenera: null },

  560: { type: TYPE.YESNO, axis: AXIS.IMMUNE, invert: true,  regenera: null },
  561: { type: TYPE.YESNO, axis: AXIS.IMMUNE, invert: true,  regenera: null },
  562: { type: TYPE.YESNO, axis: AXIS.IMMUNE, invert: false, regenera: null },
  563: { type: TYPE.YESNO, axis: AXIS.DIGEST, invert: false, regenera: null },
  564: { type: TYPE.SCALE, axis: AXIS.DIGEST, invert: false, regenera: null },
  565: { type: TYPE.SCALE, axis: AXIS.IMMUNE, invert: false, regenera: null },
  566: { type: TYPE.SCALE, axis: AXIS.DIGEST, invert: false, regenera: null },
  567: { type: TYPE.YESNO, axis: AXIS.BRAIN,  invert: false, regenera: null },

  568: { type: TYPE.SCALE, axis: AXIS.BRAIN,  invert: true,  regenera: null },
  569: { type: TYPE.SCALE, axis: AXIS.BRAIN,  invert: true,  regenera: null },
  570: { type: TYPE.SCALE, axis: AXIS.BRAIN,  invert: true,  regenera: null },
  571: { type: TYPE.YESNO, axis: AXIS.BRAIN,  invert: false, regenera: null },
  572: { type: TYPE.SCALE, axis: AXIS.BRAIN,  invert: true,  regenera: null },
  573: { type: TYPE.SCALE, axis: AXIS.BRAIN,  invert: true,  regenera: null },
  574: { type: TYPE.SCALE, axis: AXIS.BRAIN,  invert: true,  regenera: null },
  575: { type: TYPE.YESNO, axis: AXIS.BRAIN,  invert: false, regenera: null },

  576: { type: TYPE.YESNO, axis: AXIS.IMMUNE, invert: false, regenera: null },
  577: { type: TYPE.YESNO, axis: AXIS.IMMUNE, invert: false, regenera: null },
  578: { type: TYPE.SCALE, axis: AXIS.IMMUNE, invert: true,  regenera: null },
  579: { type: TYPE.SCALE, axis: AXIS.BRAIN,  invert: true,  regenera: null },
  580: { type: TYPE.SCALE, axis: AXIS.IMMUNE, invert: true,  regenera: null },
  581: { type: TYPE.YESNO, axis: AXIS.IMMUNE, invert: true,  regenera: null },
  582: { type: TYPE.YESNO, axis: AXIS.IMMUNE, invert: false, regenera: null },

  583: { type: "preferencia_pais" }
};

function normalizeValue(type, invert, raw, symId, questions) {
  if (raw == null) return null;

  if (type === TYPE.SCALE) return norm05to10(raw, { invert });
  if (type === TYPE.YESNO) return normYesNo(raw, { invert });
  if (type === TYPE.STOOL) {
    // Se vier ans_id numérico, tenta mapear para o label/letra via questions
    let letter;
    if (typeof raw === "number" && Array.isArray(questions)) {
      const q = questions.find(q => Number(q.sym_id) === Number(symId));
      const opt = q?.answers?.find(o => Number(o.ans_id) === Number(raw));
      letter = String(opt?.label ?? raw).toUpperCase();
    } else {
      letter = String(raw).toUpperCase();
    }
    if (letter === "A") return 10;
    if (letter === "B") return 0;
    if (letter === "C") return 5;
    if (letter === "D") return 10;
    return null;
  }
  return null;
}

function parentBonus(pref) {
  if (!pref) return null;
  const s = String(pref).toLowerCase();
  return ["digest", "immune", "brain", "regenera"].includes(s) ? s : null;
}

export default function evaluateKids({ answers = {}, questions = [] } = {}) {
  const r = baseResult();

  const sum = { digest: 0, immune: 0, brain: 0 };
  const count = { digest: 0, immune: 0, brain: 0 };

  let G1 = 0, G2 = 0, G3 = 0, G4 = 0;
  const reasons = [];

  Object.keys(answers).forEach(k => {
    const symId = Number(k);
    const m = meta[symId];
    if (!m || m.type === "preferencia_pais") return;

    const raw = safeGetRaw(answers, symId);
    const norm = normalizeValue(m.type, m.invert, raw, symId, questions);

    if (m.axis && norm != null) {
      sum[m.axis] += norm;
      count[m.axis] += 1;
      if (norm >= 8) reasons.push({ sym_id: symId, axis: m.axis, score: norm });
    }

    if (m.regenera === "G1" && norm === 10) G1 = 10;
    if (m.regenera === "G2" && norm >= 8)  G2 = 10;
    if (m.regenera === "G3" && norm >= 8)  G3 = 10;
    if (m.regenera === "G4" && norm === 10) G4 = 10;
  });

  const digestIdx = count.digest ? (100 * sum.digest) / (10 * count.digest) : 0;
  const immuneIdx = count.immune ? (100 * sum.immune) / (10 * count.immune) : 0;
  const brainIdx  = count.brain  ? (100 * sum.brain)  / (10 * count.brain)  : 0;

  const pref = parentBonus(safeGetRaw(answers, 583));
  let digestFinal = digestIdx, immuneFinal = immuneIdx, brainFinal = brainIdx;
  let regeneraIdx = (G1 + G2 + G3 + G4) * 2.5;

  if (pref === "digest")   digestFinal = Math.min(100, digestFinal + 10);
  if (pref === "immune")   immuneFinal = Math.min(100, immuneFinal + 10);
  if (pref === "brain")    brainFinal  = Math.min(100, brainFinal  + 10);
  if (pref === "regenera") regeneraIdx = Math.min(100, regeneraIdx + 10);

  const regFlags = G1 + G2 + G3 + G4;
  const nonRegMax = Math.max(digestFinal, immuneFinal, brainFinal);

  let sku = null;
  if (regFlags >= 20 || regeneraIdx >= 50 || (regFlags >= 10 && nonRegMax < 55)) {
    sku = "KidsRegenera";
  } else {
    const candidates = [
      { key: "KidsDigest", val: digestFinal, cnt: count.digest },
      { key: "KidsImmune", val: immuneFinal, cnt: count.immune },
      { key: "KidsBrain",  val: brainFinal,  cnt: count.brain  },
    ].sort((a,b) => b.val - a.val);

    const top = candidates.filter(c => c.val === candidates[0].val);
    if (top.length === 1) {
      sku = top[0].key;
    } else {
      const byCount = top.slice().sort((a,b) => b.cnt - a.cnt);
      sku = (byCount[0].cnt !== byCount[1]?.cnt)
        ? byCount[0].key
        : (["KidsDigest","KidsImmune","KidsBrain"].find(k => top.some(t => t.key === k)));
    }
  }

  // alerts
  const alerts = [];
  const ronco = normYesNo(safeGetRaw(answers, 554)) === 10;
  const muitosDespertares = norm05to10(safeGetRaw(answers, 553)) >= 8;
  if (ronco || muitosDespertares) {
    alerts.push("Sinais de sono não restaurador (ronco/respiração oral e/ou muitos despertares). Procure avaliação pediátrica/odontopediátrica/otorrino.");
  }
  if (G2 === 10 || G3 === 10) {
    alerts.push("Sinais de diarreia persistente e/ou uso recorrente de laxantes. Hidrate bem e avalie com pediatra se persistir.");
  }

  // preencher resultado padronizado
  r.sku = sku;
  r.scores = { Digest: Math.round(digestFinal), Immune: Math.round(immuneFinal), Brain: Math.round(brainFinal), Regenera: Math.round(regeneraIdx) };
  r.regenera_flags = { G1, G2, G3, G4 };
  r.reasons = reasons.sort((a,b) => b.score - a.score).slice(0, 5).map(r => ({ sym_id: r.sym_id, axis: r.axis, weight: r.score, label: null }));
  r.alerts = alerts;

  // Kids não usa preliminary/boosted explicitamente — mantém null
  return r;
}
